import { Link, useLocation } from 'react-router-dom';
import { msalInstance } from '../config/auth';

export function HeaderNav() {
  const location = useLocation();
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  const userName = account?.name || account?.username || null;
  const barnyardUrl = `https://${window.location.hostname.replace('app.', '')}`;

  function handleLogout() {
    msalInstance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  }

  return (
    <div className="flex items-center gap-3">
      <a
        href={barnyardUrl}
        className="text-xs text-tower-muted hover:text-tower-accent transition-colors"
        title={`Back to Barnyard (${barnyardUrl})`}
      >
        &larr; Barnyard
      </a>
      <div className="h-4 w-px bg-tower-border" />
      <Link
        to="/adlc"
        className={`text-xs transition-colors ${location.pathname === '/adlc' ? 'text-tower-accent' : 'text-tower-muted hover:text-tower-accent'}`}
      >
        ADLC
      </Link>
      <Link
        to="/docs"
        className={`text-xs transition-colors ${location.pathname === '/docs' ? 'text-tower-accent' : 'text-tower-muted hover:text-tower-accent'}`}
      >
        Docs
      </Link>
      <Link
        to="/viz"
        className={`text-xs transition-colors ${location.pathname === '/viz' ? 'text-success' : 'text-tower-muted hover:text-success'}`}
      >
        Viz
      </Link>
      <Link
        to="/roadmap"
        // startsWith, not ===, because /roadmap/detail is the same destination in the
        // reader's head. An exact match un-highlights the nav the moment someone follows
        // the link on the page, which reads as having navigated away from Roadmap.
        className={`text-xs transition-colors ${location.pathname.startsWith('/roadmap') ? 'text-tower-accent' : 'text-tower-muted hover:text-tower-accent'}`}
      >
        Roadmap
      </Link>
      <div className="h-4 w-px bg-tower-border" />
      {userName ? (
        <>
          <span className="text-xs text-tower-muted">{userName}</span>
          <button
            onClick={handleLogout}
            className="text-xs text-error hover:text-error transition-colors"
          >
            Sign out
          </button>
        </>
      ) : (
        <span className="text-xs text-tower-muted">Not signed in</span>
      )}
    </div>
  );
}
